import { observable, configure, action, computed } from 'mobx';
import StoreModel from './storeModel';
import util from '../lib/util';

configure({ enforceActions: 'always' });

class TagStore extends StoreModel {
    constructor() {
        super('tag', {
            namePlural: 'tags',
            sort: '-pinned,name',
            api: {
                search: {
                    url: '/api/tags/',
                    params: {},
                },
                load: {
                    url: '/api/tags/',
                    params: {},
                },
                save: {
                    url: '/api/tags/',
                    params: {},
                },
            },
            extendedView: 1,
            queryFilter: {},
        });
    }

    @observable tag = {};

    @observable tags = [];

    @observable tagTree = [];

    @observable tagTreeBranch = [];

    @observable tagTreeBranchPinned = [];

    @observable tagTreeParent = util.get(`${this.name}tagTreeParent`);

    @observable tagListTree = [];
}

const store = new TagStore();
export default store;



// WEBPACK FOOTER //
// ./stores/tag.js